import { AxiosError } from 'axios';
import { FC, PropsWithChildren, useEffect } from 'react';
import {
  apiClient,
  isApiSessionExpiredOrNotStarted,
} from '../common/ApiClient';
import { emitLogout } from './events';
import { useGotoLogin } from './useGotoLogin';
import { useUserInfoQuery } from './query/useUserInfoQuery';

export const RequireAuth: FC<PropsWithChildren> = (props) => {
  const { children } = props;
  const gotoLogin = useGotoLogin();
  const { error, status } = useUserInfoQuery({ throwOnError: false });

  useEffect(() => {
    const gotoLoginWithParams = (error: AxiosError<unknown>) => {
      emitLogout();
      const { pathname, search } = window.location;
      const errorCode = (error?.response?.data as any)?.errors?.[0]?.code;
      gotoLogin(pathname + search, errorCode);
    };

    if (error && isApiSessionExpiredOrNotStarted(error)) {
      gotoLoginWithParams(error);
    }

    return apiClient.subscribe({
      event: 'response',
      onError: (error) => {
        if (isApiSessionExpiredOrNotStarted(error)) {
          gotoLoginWithParams(error);
        }
        throw error;
      },
    });
  }, [gotoLogin, error]);

  if (status === 'success') {
    return children;
  }

  return null;
};
